// import packages
import axios from 'axios'

// import lib
import config from '../config/config'
import { getAuthToken } from '../helper/localstorage'

axios.defaults.baseURL = config.p2pUrl
axios.defaults.headers.common['Authorization'] = getAuthToken()

export const setAuthorization = (token) => {
  axios.defaults.headers.common['Authorization'] = token
}
export default axios